import React from "react";

const TableDefaultSvg = ({ data }) => {
  return (
    <>
      <svg
        data-name="#000000ff"
        xmlns="http://www.w3.org/2000/svg"
        width={data?.width ? data?.width : "103.352"}
        height={data?.height ? data?.height : "103.352"}
        viewBox="0 0 103.352 103.352"
      >
        <path
          data-name="Path 1465"
          d="M62.282 0h1.378a40.452 40.452 0 0 1 38.293 29.851 41.563 41.563 0 0 1 1.4 9.816v2.089a40.962 40.962 0 0 1-5.868 19.594 11.855 11.855 0 0 1 1.04 2.25 6.749 6.749 0 0 1 4.826 5.82v1a6.621 6.621 0 0 1-6.861 6.086c-4.986-.01-9.974 0-14.96-.008a3.475 3.475 0 0 0-1.661.541 40.411 40.411 0 0 1-33.916-.075A42.481 42.481 0 0 1 40.663 74q-11.7 12.211-23.4 24.419a22.386 22.386 0 0 1-3.971 3.69 9.118 9.118 0 0 1-4.112 1.245H8.4a8.9 8.9 0 0 1-6.32-3.113A9.156 9.156 0 0 1 0 95.255v-1.207a8.948 8.948 0 0 1 2.681-5.791Q16.012 75.47 29.354 62.689a40.326 40.326 0 0 1-4.619-35.261c-5.218-.008-10.438 0-15.658-.006a6.845 6.845 0 0 1-5.958-10.145A7 7 0 0 1 8.3 13.759a11.816 11.816 0 0 1 4.306-7.182 11.649 11.649 0 0 1 9.8-2.212 11.989 11.989 0 0 1 6.635 4.189 8.567 8.567 0 0 1 6.453 2.277A41.389 41.389 0 0 1 42.4 5.658 40.419 40.419 0 0 1 62.282 0M51.2 6a36.526 36.526 0 0 0-17.958 13.53 36.331 36.331 0 0 0 34.972 56.8 7.174 7.174 0 0 1-4.463-3.66A32.925 32.925 0 0 1 52.6 70.949a32.479 32.479 0 0 1-15.961-11.923 32.246 32.246 0 0 1-2.222-33.713 2.018 2.018 0 0 1 2.921-.69 2.073 2.073 0 0 1 .553 2.751 28.282 28.282 0 0 0 25.242 41.258 6.968 6.968 0 0 1 5.967-5.785 11.69 11.69 0 0 1 18-7.733 28.261 28.261 0 0 0-37.108-39.837 2.072 2.072 0 0 1-2.743-.529 2.013 2.013 0 0 1 .672-2.939A32.3 32.3 0 0 1 90.3 57.613a8.738 8.738 0 0 1 4.13.967A36.335 36.335 0 0 0 51.2 6M14.932 9.881a7.712 7.712 0 0 0-2.759 5.846 2.014 2.014 0 0 1-1.677 2A6.66 6.66 0 0 0 7.8 18.1a2.805 2.805 0 0 0-1.3 3.476 2.856 2.856 0 0 0 2.77 1.811h17.089a40.777 40.777 0 0 1 6.318-9.663 4.362 4.362 0 0 0-4.013-1.007 2.031 2.031 0 0 1-2.287-.894 7.628 7.628 0 0 0-11.449-1.94m64.891 47.352a7.67 7.67 0 0 0-5.834 3.813 7.833 7.833 0 0 0-1.013 3.765 2.015 2.015 0 0 1-1.916 2.023c-1.005.026-2.138-.071-2.937.672a2.819 2.819 0 0 0-.014 4.285 3.958 3.958 0 0 0 2.947.676q12.823-.009 25.644 0a2.518 2.518 0 0 0 1.536-4.578c-.822-.672-2.073-.218-2.824-1.015-.779-.67-.543-1.8-.963-2.656a4.225 4.225 0 0 0-4.818-2.44 2.113 2.113 0 0 1-2.485-.931 7.632 7.632 0 0 0-7.323-3.609m-53.2 13.67 5.83 5.832q2.477-2.58 4.948-5.16a43.413 43.413 0 0 1-5.612-5.62q-2.589 2.468-5.166 4.948M5.533 91.109a4.747 4.747 0 1 0 6.708 6.714q8.705-9.087 17.41-18.169c-1.98-1.988-3.969-3.965-5.949-5.953Q14.61 82.4 5.533 91.109Z"
          fill="#efefef"
        />
        <path
          data-name="Path 1466"
          d="M40.848 17.078a2.013 2.013 0 1 1-.6 3.4 2.029 2.029 0 0 1 .6-3.4Z"
          fill="#efefef"
        />
        <path
          data-name="Path 1467"
          d="M52.171 38.487a2.015 2.015 0 1 1-1.245 2.323 2.027 2.027 0 0 1 1.245-2.323Z"
          fill="#efefef"
        />
        <path
          data-name="Path 1468"
          d="M62.262 38.488a2.014 2.014 0 1 1-.61 3.4 2.028 2.028 0 0 1 .61-3.4Z"
          fill="#efefef"
        />
        <path
          data-name="Path 1469"
          d="M72.36 38.487a2.014 2.014 0 1 1-.6 3.407 2.026 2.026 0 0 1 .6-3.407Z"
          fill="#efefef"
        />
      </svg>
    </>
  );
};

const NoSearchTableSvg = ({ data }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="101.41"
        height="105.066"
        viewBox="0 0 101.41 105.066"
      >
        <g id="Not_Found" data-name="Not Found" transform="translate(0.002)">
          <path
            id="Path_1475"
            data-name="Path 1475"
            d="M44.6,14.774a1.976,1.976,0,0,1,.676-2.828,32.85,32.85,0,0,1,40.746,7.737,31.634,31.634,0,0,1-1.6,42.409,32.872,32.872,0,0,1-42.95,3.553,31.952,31.952,0,0,1-12.383-19.14,31.558,31.558,0,0,1,2.641-20.6,1.989,1.989,0,0,1,2.776-.8h0a2.221,2.221,0,0,1,.851,2.912A27.478,27.478,0,0,0,33.2,45.666,27.825,27.825,0,0,0,43.982,62.333a28.627,28.627,0,0,0,37.4-3.094,27.548,27.548,0,0,0,1.392-36.931,28.607,28.607,0,0,0-35.295-6.839,2.2,2.2,0,0,1-2.883-.695Z"
            fill="#efefef"
          />
          <path
            id="Path_1476"
            data-name="Path 1476"
            d="M101.409,40.5A40.5,40.5,0,1,1,60.91,0,40.5,40.5,0,0,1,101.409,40.5Zm-76.949,0A36.45,36.45,0,1,0,60.91,4.05,36.45,36.45,0,0,0,24.459,40.5Z"
            fill="#efefef"
          />
          <path
            id="Path_1477"
            data-name="Path 1477"
            d="M2.685,95.2l19.4-18.734,6.405,6.555C21.111,90.86,13.06,99.374,11.172,101.263c-1.608,1.607-2.785,2.087-3.76,2.051-1.022-.038-2.37-.657-4.265-2.551a4.027,4.027,0,0,1-1.382-3.306A4.31,4.31,0,0,1,2.685,95.2ZM30.894,80.472l-6.288-6.436,5.782-5.583,6.085,6.085C34.837,76.28,32.925,78.314,30.894,80.472Z"
            fill="none"
            stroke="#efefef"
            strokeWidth="3.5"
          />
          <path
            id="Path_1478"
            data-name="Path 1478"
            d="M71,31,51,51"
            fill="none"
            stroke="#efefef"
            stroke-linecap="round"
            strokeWidth="5"
          />
          <path
            id="Path_1479"
            data-name="Path 1479"
            d="M51,31,71,51"
            fill="none"
            stroke="#efefef"
            stroke-linecap="round"
            strokeWidth="5"
          />
        </g>
      </svg>
    </>
  );
};

export { TableDefaultSvg, NoSearchTableSvg };
